/* eslint-disable max-len */
<template>
  <div class="container-fluid text-center">
    <h1 class="title">
      Gic Customer portal
    </h1>
    <button type="button" class="btn btn-primary mr-3" @click="checkSSi">Check SSI login</button>
    <button type="button" class="btn btn-primary mr-3" @click="checkMSAL">Check MSAL login</button>
    <button type="button" class="btn btn-primary mr-3" @click="getProfile">Get profile</button>
    <button type="button" class="btn btn-primary mr-3" @click="sendEmail">Send email</button>
    <button type="button" class="btn btn-primary mr-3" @click="getEmail">Get email</button>
    <button type="button" class="btn btn-primary mr-3" @click="getCalendar">Get calendar</button>
    <button type="button" class="btn btn-danger" @click="logout">Logout</button>
    <button type="button" class="btn btn-primary mr-3" @click="checkSSO">Check SSO login</button>
    <!-- <button type="button" class="btn btn-primary" @click="getImage">Image</button> -->
    <!-- <h4>Insurance company</h4> -->
  </div>
</template>

<script>
import { Client } from '@microsoft/microsoft-graph-client';
import * as Msal from 'msal';
// import * as msal2 from '@azure/msal-browser';

import { ImplicitMSALAuthenticationProvider } from '@microsoft/microsoft-graph-client/lib/src/ImplicitMSALAuthenticationProvider';
import { MSALAuthenticationProviderOptions } from '@microsoft/microsoft-graph-client/lib/src/MSALAuthenticationProviderOptions';

import image from '@/assets/img/storm.png';
import axios from 'axios';
import qs from 'qs';

export default {
  data() {
    return {
      msalConfig: {
        auth: {
          // clientId: 'b1ae16d5-1608-432c-886f-c29bdc39fea3',
          clientId: 'e8b1f24e-d6e4-4adc-b2fb-e93c25befc5f',
          authority: 'https://login.microsoftonline.com/be2c1f8d-3ffe-4ada-ad5f-0c53b80d29d0/',
          // authority: 'https://login.microsoftonline.com/common/',
          // redirectUri: 'http://localhost:8080/about',
          postLogoutRedirectUri: 'http://localhost:8080/about'
        },
        cache: {
          cacheLocation: 'sessionStorage', // This configures where your cache will be stored
          storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
        }
      }
    };
  },
  methods: {
    getImage() {
      console.log(image);
    },
    // eslint-disable-next-line max-len
    async checkSSO() {
      const APP_ID = 'e8b1f24e-d6e4-4adc-b2fb-e93c25befc5f';
      // const APP_SECERET = '~WXI1~y.8a6LXf7INkn~9WFyb3FK-1D1s6';
      // const TOKEN_ENDPOINT = 'https://login.microsoftonline.com/be2c1f8d-3ffe-4ada-ad5f-0c53b80d29d0/oauth2/v2.0/token ';
      // const MS_GRAPH_SCOPE = 'https://graph.microsoft.com/.default';
      const response = await axios.post('https://login.microsoftonline.com/be2c1f8d-3ffe-4ada-ad5f-0c53b80d29d0/oauth2/v2.0/authorize', qs.stringify(
        {
          client_id: APP_ID,
          response_type: 'code',
          scope: 'offline_access user.read mail.read',
          redirect_uri: 'http://localhost:8080/about'
        }
      ));
      console.log(response);
      // const response2 = await axios.post(TOKEN_ENDPOINT, qs.stringify(
      //   {
      //     client_id: APP_ID,
      //     scope: 'offline_access user.read mail.read',
      //     client_secret: '~WXI1~y.8a6LXf7INkn~9WFyb3FK-1D1s6',
      //     grant_type: 'authorization_code',
      //     // code: '258acba7-2393-4732-bd2e-1fcb3183cd73'
      //   }
      // ));
      // console.log(response2);
      // eslint-disable-next-line max-len
      // https://login.microsoftonline.com/be2c1f8d-3ffe-4ada-ad5f-0c53b80d29d0/oauth2/v2.0/authorize?client_id=e8b1f24e-d6e4-4adc-b2fb-e93c25befc5f&response_type=code&scope=offline_access%20user.read%20mail.read
    },
    async checkMSAL() {
      // Config object to be passed to Msal on creation
      const { msalConfig } = this;

      const myMSALObj = new Msal.UserAgentApplication(msalConfig);
      // const myMSALObj = new Msal.PublicClientApplication(msalConfig);
      // Add scopes for the id token to be used at Microsoft identity platform endpoints.
      const loginRequest = {
        scopes: ['openid', 'profile', 'User.Read']
      };
      const account = myMSALObj.getAccount();
      console.log(myMSALObj);
      if (account) {
        const token = await myMSALObj.acquireTokenSilent(loginRequest);
        console.log(token);
      } else {
        const respone = await myMSALObj.loginPopup(loginRequest);
        console.log(respone);
      }
    },
    async checkSSi() {
      // const APP_ID = 'b1ae16d5-1608-432c-886f-c29bdc39fea3';
      // const APP_SECERET = '84_4s_20Q~N-MbTe.dn31xNj2Am3bl2-H0';
      // const TOKEN_ENDPOINT = 'https://login.microsoftonline.com/f8cdef31-a31e-4b4a-93e4-5f571e91255a/oauth2/v2.0/token';
      // const MS_GRAPH_SCOPE = 'https://graph.microsoft.com/.default';
      // const { msalConfig } = this;
      // const msalInstance = new msal2.PublicClientApplication(msalConfig);
      // console.log(msalInstance);
      /*  const postData = {
        client_id: APP_ID,
        scope: MS_GRAPH_SCOPE,
        client_secret: APP_SECERET,
        grant_type: 'client_credentials'
      };
      // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
      const respone = await axios.post(TOKEN_ENDPOINT, qs.stringify(postData));
      console.log(respone); */

      // // axios.defaults.headers.common.Authorization = `Bearer ${respone.data.access_token}`;
      // const respone2 = await axios.get('https://graph.microsoft.com/v1.0/users',
      //   {
      //     headers: {
      //       Authorization: `Bearer ${respone.data.access_token}`
      //     }
      //   });
      // console.log(respone2);
      const respone3 = await axios.post('https://login.microsoftonline.com/be2c1f8d-3ffe-4ada-ad5f-0c53b80d29d0/oauth2/v2.0/token', qs.stringify(
        {
          client_id: 'e8b1f24e-d6e4-4adc-b2fb-e93c25befc5f',
          scope: 'https://graph.microsoft.com/.default',
          client_secret: '~WXI1~y.8a6LXf7INkn~9WFyb3FK-1D1s6',
          grant_type: 'client_credentials'
        }
      ),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Access-Control-Allow-Origin': '*'
        }
      });
      console.log(respone3);
      /*  const mail = {
        subject: 'Microsoft Graph JavaScript Sample',
        toRecipients: [
          {
            emailAddress: {
              address: 'goumastolis@hotmail.com'
            }
          }
        ],
        body: {
          content: '<h1>MicrosoftGraph JavaScript Sample</h1>Check out https://github.com/microsoftgraph/msgraph-sdk-javascript',
          contentType: 'html'
        },
        singleValueExtendedProperties: [
          {
            id: 'String {4E97BC98-5CC8-44F9-A2FC-6F732B3A49EA} Name I_ENTITY_ID',
            value: '052'
          }
        ]
      }; */
      // eslint-disable-next-line max-len
      const respone5 = await axios.get('https://graph.microsoft.com/v1.0/users/258acba7-2393-4732-bd2e-1fcb3183cd73/mailFolders/AQMkAGM5NTczYTFlLTliYTEtNDQANWYtOTM2My0yNjdkNWE0ZTFjODAALgAAAyMZaZOOaKBMhdQ-ZZljbEcBAKnaVuDrpKFAh-W8ooo9B0EAAAIBCQAAAA==/messages',
        {
          headers: {
            Authorization: `${respone3.data.token_type} ${respone3.data.access_token}`
          },
        });
      console.log(respone5);
      // axios.defaults.headers.common.Authorization = `${respone3.data.token_type} ${respone3.data.access_token}`;
      // eslint-disable-next-line max-len
      /*  const respone2 = await axios.post('https://graph.microsoft.com/v1.0/users/258acba7-2393-4732-bd2e-1fcb3183cd73/sendMail', {
        message: mail
      },
      // headers: {
      //   Authorization: `${respone3.data.token_type} ${respone3.data.access_token}`
      // }
      );
      console.log(respone2); */
      const id = 'String {4E97BC98-5CC8-44F9-A2FC-6F732B3A49EA} Name I_ENTITY_ID';
      // eslint-disable-next-line max-len
      const response5 = await axios.get('https://graph.microsoft.com/v1.0/users/258acba7-2393-4732-bd2e-1fcb3183cd73/messages', {
        headers: {
          Authorization: `${respone3.data.token_type} ${respone3.data.access_token}`
        },
        params: {
          $filter: `singleValueExtendedProperties/Any(ep: ep/id eq '${id}' and ep/value eq '052')`
        }
      });
      console.log(response5);
      // eslint-disable-next-line max-len
      /* const response6 = await axios.get('https://graph.microsoft.com/v1.0/users/258acba7-2393-4732-bd2e-1fcb3183cd73/messages/AAMkAGM5NTczYTFlLTliYTEtNDQ1Zi05MzYzLTI2N2Q1YTRlMWM4MABGAAAAAAAjGWmTjmigTIXUP2WZY2xHBwCp2lbg66ShQIf1vKKKPQdBAAAAAAEJAACp2lbg66ShQIf1vKKKPQdBAAK1mDI2AAA=', {
        headers: {
          Authorization: `${respone3.data.token_type} ${respone3.data.access_token}`
        }
      });
      console.log(response6); */
    },
    async logout() {
      // Config object to be passed to Msal on creation
      const { msalConfig } = this;
      const myMSALObj = new Msal.UserAgentApplication(msalConfig);
      await myMSALObj.logout();
      // console.log(response);
    },
    async getProfile() {
      console.log('getprofile');
      const { msalConfig } = this;
      const graphScopes = ['user.read', 'mail.send']; // An array of graph scopes

      const msalApplication = new Msal.UserAgentApplication(msalConfig);
      const options = new MSALAuthenticationProviderOptions(graphScopes);
      const authProvider = new ImplicitMSALAuthenticationProvider(msalApplication, options);
      const client = Client.initWithMiddleware({ authProvider });
      const userDetails = await client.api('/me').get();
      console.log(userDetails);
    },
    async sendEmail() {
      console.log('sendemail');
      const { msalConfig } = this;
      const graphScopes = ['user.read', 'mail.send']; // An array of graph scopes

      const msalApplication = new Msal.UserAgentApplication(msalConfig);
      const options = new MSALAuthenticationProviderOptions(graphScopes);
      const authProvider = new ImplicitMSALAuthenticationProvider(msalApplication, options);
      const client = Client.initWithMiddleware({ authProvider });
      // Construct email object
      const mail = {
        subject: 'Microsoft Graph JavaScript Sample',
        toRecipients: [
          {
            emailAddress: {
              address: 'agkoumas@improvit.gr'
            }
          }
        ],
        body: {
          content: '<h1>MicrosoftGraph JavaScript Sample</h1>Check out https://github.com/microsoftgraph/msgraph-sdk-javascript',
          contentType: 'html'
        },
        attachments: [
          {
            '@odata.type': '#microsoft.graph.fileAttachment',
            name: 'Attachement.png',
            contentType: 'image/png',
            // size: 6497,
            // isInline: true,
            // contentId: 'starfish',
            // contentLocation: null,
            contentBytes:
              // eslint-disable-next-line max-len
              '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'
          }
        ],
        singleValueExtendedProperties: [
          {
            id: 'String {66f5a359-4659-4830-9070-00047ec6ac6e} Name Color',
            value: 'Green'
          }
        ]
      };
      const response = await client.api('/me/sendMail').post({ message: mail });
      console.log(response);
    },
    async getCalendar() {
      console.log('get Calendar');
      const { msalConfig } = this;
      const graphScopes = ['user.read', 'Calendars.Read']; // An array of graph scopes

      const msalApplication = new Msal.UserAgentApplication(msalConfig);
      const options = new MSALAuthenticationProviderOptions(graphScopes);
      const authProvider = new ImplicitMSALAuthenticationProvider(msalApplication, options);
      const client = Client.initWithMiddleware({ authProvider });
      const userDetails = await client.api('/me/calendar/events').get();
      console.log(userDetails);
    },
    async getEmail() {
      console.log('get Emails');
      const { msalConfig } = this;
      const graphScopes = ['user.read', 'Mail.Read']; // An array of graph scopes

      const msalApplication = new Msal.UserAgentApplication(msalConfig);
      const options = new MSALAuthenticationProviderOptions(graphScopes);
      const authProvider = new ImplicitMSALAuthenticationProvider(msalApplication, options);
      const client = Client.initWithMiddleware({ authProvider });
      const userDetails = await client.api('/me/mailFolders').get();
      console.log(userDetails);
      const emails = await client.api(`/me/mailFolders/${userDetails.value[1].id}/messages`).get();
      console.log('Programming Folder', emails);
      const emails3 = await client.api('/me/messages').get();
      console.log('Recent mails', emails3);
      // eslint-disable-next-line max-len
      const id = 'String {66f5a359-4659-4830-9070-00047ec6ac6e} Name Color';
      const value = 'Green';
      const emails2 = await client.api(`/me/messages?$filter=singleValueExtendedProperties/Any(ep: ep/id eq '${id}' and ep/value eq '${value}')`).get();
      console.log('With tag emails', emails2);
    }
  }
};
</script>
